const types = {
    GET_FUENTES_ABIERTAS: 'GET_FUENTES_ABIERTAS',
    STORE_FUENTES: 'STORE_FUENTES',
    CLEAR_FUENTES: 'CLEAR_FUENTES'
}

export default types;

export const getFuentesAbiertas = () => {
    return { type: types.GET_FUENTES_ABIERTAS };
}

export const storeFuentesAbiertas = (fuentesAbiertas) => {
    return { type: types.STORE_FUENTES, payload: fuentesAbiertas };
}

export const clearFuentesAbiertas = () => {
    return { type: types.CLEAR_FUENTES };
}